import { routes } from "router";


export type SubChildren = {
    href: string;
    label: string;
    active: boolean;
    children?: SubChildren[];
};
export type Submenu = {
    href: string;
    label: string;
    active: boolean;
    icon: any;
    submenus?: Submenu[];
    children?: SubChildren[];
    badge?: string;
};

export type Menu = {
    href: string;
    label: string;
    active: boolean;
    icon: any;
    submenus: Submenu[];
    badge?: string;
    id: string;
};

export type Group = {
    groupLabel: string;
    menus: Menu[];
    id: string;
};

export function getMenuList(pathname: string): Group[] {

    return [
        {
            groupLabel: ("dashboard"),
            id: "dashboard",
            menus: [
                {
                    id: "dashboard",
                    href: routes.Home.path,
                    label: ("dashboard"),
                    active: pathname === routes.Home.path,
                    icon: "heroicons-outline:home",
                    submenus: [], // empty
                },
                {
                    id: "orders",
                    href: routes.Orders.path,
                    label: ("orders"),
                    active: pathname.includes(routes.Orders.path),
                    icon: "heroicons:shopping-bag",
                    submenus: [],
                },
            ],
        },
        {
            groupLabel: "Product",
            id: "add-product",
            menus: [
                {
                    id: "add-product",
                    href: routes.AddProduct.path,
                    label: ("add product"),
                    active: pathname.includes(routes.AddProduct.path),
                    icon: "heroicons:plus-circle",
                    submenus: [],
                },
                {
                    id: "product-listing",
                    href: routes.ProductList.path,
                    label: ("product list"),
                    active: pathname.includes(routes.ProductList.path),
                    icon: "heroicons:list-bullet",
                    submenus: [],
                },
            ],
        },
        {
            groupLabel: "Marketing",
            id: "marketing",
            menus: [
                {
                    id: "meta-ads",
                    href: routes.MetaAds.path,
                    label: ("Meta Ads"),
                    active: pathname.startsWith(routes.MetaAds.path),
                    badge: "New",
                    icon: "heroicons:megaphone",
                    submenus: [],
                },
            ],
        },
        {
            groupLabel: "Settings & Support",
            id: "settings",
            menus: [
                {
                    id: "web-builder",
                    href: routes.WebBuilder.path,
                    label: ("Web Builder"),
                    active: pathname.includes(routes.WebBuilder.path),
                    icon: "heroicons-outline:cog",
                    submenus: [],
                },
                {
                    id: "checkout-fees",
                    href: routes.CheckoutFees.path,
                    label: ("Checkout Fees"),
                    active: pathname.includes(routes.CheckoutFees.path),
                    icon: "heroicons:banknotes",
                    submenus: [],
                },
                {
                    id: "help",
                    href: routes.Help.path,
                    label: ("Help & Support"),
                    active: pathname.includes(routes.Help.path),
                    icon: "heroicons:lifebuoy",
                    submenus: [],
                },
            ],
        },
        // {
        //   groupLabel: ("apps"),
        //   id: "app",
        //   menus: [
        //     {
        //       id: "chat",
        //       href: "/app/chat",
        //       label: ("chat"),
        //       active: pathname.includes("/app/chat"),
        //       icon: "heroicons-outline:chat",
        //       submenus: [],
        //     },
        //     {
        //       id: "email",
        //       href: "/app/email",
        //       label: ("email"),
        //       active: pathname.includes("/app/email"),
        //       icon: "heroicons-outline:mail",
        //       submenus: [],
        //     },
        //     {
        //       id: "calendar",
        //       href: "/app/calendar",
        //       label: ("calendar"),
        //       active:pathname.includes("/app/calendar"),
        //       icon: "heroicons-outline:calendar",
        //       submenus: [],
        //     },
        //     {
        //       id: "todo",
        //       href: "/app/todo",
        //       label: ("todo"),
        //       active:pathname.includes("/app/todo"),
        //       icon: "heroicons-outline:clipboard-check",
        //       submenus: [],
        //     },
        //   ],
        // },
        // {
        //   groupLabel: "",
        //   id: "ecommerce",
        //   menus: [
        //     {
        //       id: "ecommerce",
        //       href: "/ecommerce/frontend",
        //       label: ("ecommerce"),
        //       active: pathname.includes("/ecommerce"),
        //       icon: "heroicons-outline:shopping-bag",
        //       submenus: [
        //         {
        //           href: "/ecommerce/frontend",
        //           label: ("userApp"),
        //           active: pathname.includes("/ecommerce/frontend"),
        //           icon: "heroicons-outline:user",
        //           children: [
        //             {
        //               href: "/ecommerce/frontend",
        //               label: ("products"),
        //               active: pathname === "/ecommerce/frontend",
        //             },
        //             {
        //               href: "/ecommerce/frontend/c06d48bf-7f35-4789-b71e-d80fee5b430t",
        //               label: ("productDetails"),
        //               active:
        //                 pathname ===
        //                 "/ecommerce/frontend/c06d48bf-7f35-4789-b71e-d80fee5b430t",
        //             },
        //             {
        //               href: "/ecommerce/frontend/checkout/cart",
        //               label: ("cart"),
        //               active: pathname === "/ecommerce/frontend/checkout/cart",
        //             },
        //             {
        //               href: "/ecommerce/frontend/wishlist",
        //               label: ("wishlist"),
        //               active: pathname === "/ecommerce/frontend/wishlist",
        //             },
        //           ],
        //         },
        //         {
        //           href: "/ecommerce/backend",
        //           label: ("adminApp"),
        //           active: pathname.includes("/ecommerce/backend"),
        //           icon: "heroicons-outline:user-circle",
        //           children: [
        //             {
        //               href: "/ecommerce/backend/add-product",
        //               label: ("addProduct"),
        //               active: pathname === "/ecommerce/backend/add-product",
        //             },
        //             {
        //               href: "/ecommerce/backend/customer-list",
        //               label: ("customerList"),
        //               active: pathname === "/ecommerce/backend/customer-list",
        //             },
        //             {
        //               href: "/ecommerce/backend/edit-product",
        //               label: ("editProduct"),
        //               active: pathname === "/ecommerce/backend/edit-product",
        //             },
        //             {
        //               href: "/ecommerce/backend/invoice",
        //               label: ("invoice"),
        //               active: pathname === "/ecommerce/backend/invoice",
        //             },
        //             {
        //               href: "/ecommerce/backend/order-details",
        //               label: ("orderDetails"),
        //               active: pathname === "/ecommerce/backend/order-details",
        //             },
        //             {
        //               href: "/ecommerce/backend/order-list",
        //               label: ("orderList"),
        //               active: pathname === "/ecommerce/backend/order-list",
        //             },
        //             {
        //               href: "/ecommerce/backend/purchase-list",
        //               label: ("purchaseList"),
        //               active: pathname === "/ecommerce/backend/purchase-list",
        //             },
        //             {
        //               href: "/ecommerce/backend/sellers",
        //               label: ("sellers"),
        //               active: pathname === "/ecommerce/backend/sellers",
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   groupLabel: ("pages"),
        //   id: "auth",
        //   menus: [
        //     {
        //       id: "auth",
        //       href: "/auth/login",
        //       label: ("authentication"),
        //       active: pathname.includes("/auth"),
        //       icon: "heroicons-outline:lock-closed",
        //       submenus: [
        //         {
        //           href: "/auth/login",
        //           label: ("signInOne"),
        //           active: pathname === "/auth/login",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/login2",
        //           label: ("signInTwo"),
        //           active: pathname === "/auth/login2",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/login3",
        //           label: ("signInThree"),
        //           active: pathname === "/auth/login3",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/register",
        //           label: ("signUpOne"),
        //           active: pathname === "/auth/register",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/register2",
        //           label: ("signUpTwo"),
        //           active: pathname === "/auth/register2",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/register3",
        //           label: ("signUpThree"),
        //           active: pathname === "/auth/register3",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/forgot-password",
        //           label: ("forgotPasswordOne"),
        //           active: pathname === "/auth/forgot-password",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/forgot-password2",
        //           label: ("forgotPasswordTwo"),
        //           active: pathname === "/auth/forgot-password2",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/forgot-password3",
        //           label: ("forgotPasswordThree"),
        //           active: pathname === "/auth/forgot-password3",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/look-screen",
        //           label: ("lockScreenOne"),
        //           active: pathname === "/auth/look-screen",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/look-screen",
        //           label: ("lockScreenTwo"),
        //           active: pathname === "/auth/look-screen2",
        //           icon: "",
        //           children: [],
        //         },
        //         {
        //           href: "/auth/look-screen3",
        //           label: ("lockScreenThree"),
        //           active: pathname === "/auth/look-screen3",
        //           icon: "",
        //           children: [],
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   groupLabel: "",
        //   id: "utility",
        //   menus: [
        //     {
        //       id: "utility",
        //       href: "/utility/blank-page",
        //       label: ("utility"),
        //       active: pathname.includes("/utility"),
        //       icon: "heroicons-outline:view-boards",
        //       submenus: [
        //         {
        //           href: "/utility/blank-page",
        //           label: ("blankPage"),
        //           active: pathname === "/utility/blank-page",
        //           icon: "heroicons:document",
        //           children: [],
        //         },
        //         {
        //           href: "/utility/blog",
        //           label: ("blog"),
        //           active: pathname === "/utility/blog",
        //           icon: "heroicons:square-2-stack",
        //           children: [],
        //         },
        //         {
        //           href: "/utility/faq",
        //           label: ("faq"),
        //           active: pathname === "/utility/faq",
        //           icon: "heroicons:question-mark-circle",
        //           children: [],
        //         },
        //         {
        //           href: "/utility/invoice",
        //           label: ("invoice"),
        //           active: pathname === "/utility/invoice",
        //           icon: "heroicons:clipboard-document-list",
        //           children: [],
        //         },
        //         {
        //           href: "/utility/pricing",
        //           label: ("pricing"),
        //           active: pathname === "/utility/pricing",
        //           icon: "heroicons:currency-dollar",
        //           children: [],
        //         },
        //         {
        //           href: "/utility/profile",
        //           label: ("profile"),
        //           active: pathname === "/utility/profile",
        //           icon: "heroicons:user-circle",
        //           children: [],
        //         },
        //         {
        //           href: "/utility/settings",
        //           label: ("settings"),
        //           active: pathname === "/utility/settings",
        //           icon: "heroicons:wrench-screwdriver",
        //           children: [],
        //         },
        //       ],
        //     },
        //   ],
        // },
    ];
}

// Unused no horizontal menu
export function getHorizontalMenuList(pathname: string): Group[] {
    return [
        {
            groupLabel: ("dashboard"),
            id: "dashboard",
            menus: [
                {
                    id: "dashboard",
                    href: "/dashboard/analytics",
                    label: ("dashboard"),
                    active: pathname.includes("/dashboard"),
                    icon: "heroicons-outline:home",
                    submenus: [
                        {
                            href: "/dashboard/analytics",
                            label: ("analytics"),
                            active: pathname === "/dashboard/analytics",
                            icon: "heroicons:arrow-trending-up",
                            children: [],
                        },
                        {
                            href: "/dashboard/dash-ecom",
                            label: ("ecommerce"),
                            active: pathname === "/dashboard/dash-ecom",
                            icon: "heroicons:shopping-cart",
                            children: [],
                        },
                        {
                            href: "/dashboard/project",
                            label: ("project"),
                            active: pathname === "/dashboard/project",
                            icon: "heroicons:document",
                            children: [],
                        },
                        {
                            href: "/dashboard/crm",
                            label: ("crm"),
                            active: pathname === "/dashboard/crm",
                            icon: "heroicons:share",
                            children: [],
                        },
                        {
                            href: "/dashboard/banking",
                            label: ("banking"),
                            active: pathname === "/dashboard/banking",
                            icon: "heroicons:credit-card",
                            children: [],
                        },
                    ],
                },
            ],
        },

        {
            groupLabel: ("apps"),
            id: "app",
            menus: [
                {
                    id: "app",
                    href: "/app/chat",
                    label: ("apps"),
                    active: pathname.includes("/app/chat"),
                    icon: "heroicons-outline:chat",
                    submenus: [
                        {
                            href: "/app/chat",
                            label: ("chat"),
                            active: pathname === "/app/chat",
                            icon: "heroicons-outline:chat",
                            children: [],
                        },
                        {
                            href: "/app/email",
                            label: ("email"),
                            active: pathname === "/app/email",
                            icon: "heroicons-outline:mail",
                            children: [],
                        },
                        {
                            href: "/app/calendar",
                            label: ("calendar"),
                            active: pathname === "/app/calendar",
                            icon: "heroicons-outline:calendar",
                            children: [],
                        },
                        {
                            href: "/app/todo",
                            label: ("todo"),
                            active: pathname === "/app/todo",
                            icon: "heroicons-outline:clipboard-check",
                            children: [],
                        },
                    ],
                },
            ],
        },
        {
            groupLabel: ("ecommerce"),
            id: "ecommerce",
            menus: [
                {
                    id: "ecommerce",
                    href: "/ecommerce/frontend",
                    label: ("ecommerce"),
                    active: pathname.includes("/ecommerce"),
                    icon: "heroicons-outline:shopping-bag",
                    submenus: [
                        {
                            href: "/ecommerce/frontend",
                            label: ("userApp"),
                            active: pathname === "/ecommerce/frontend",
                            icon: "heroicons-outline:user",
                            children: [
                                {
                                    href: "/ecommerce/frontend",
                                    label: ("products"),
                                    active: pathname === "/ecommerce/frontend",
                                },
                                {
                                    href: "/ecommerce/frontend/c06d48bf-7f35-4789-b71e-d80fee5b430t",
                                    label: ("productDetails"),
                                    active:
                                        pathname ===
                                        "/ecommerce/frontend/c06d48bf-7f35-4789-b71e-d80fee5b430t",
                                },
                                {
                                    href: "/ecommerce/frontend/checkout/cart",
                                    label: ("cart"),
                                    active: pathname === "/ecommerce/frontend/checkout/cart",
                                },
                                {
                                    href: "/ecommerce/frontend/wishlist",
                                    label: ("wishlist"),
                                    active: pathname === "/ecommerce/frontend/wishlist",
                                },
                            ],
                        },
                        {
                            href: "/ecommerce/backend",
                            label: ("adminApp"),
                            active: pathname === "/ecommerce/backend",
                            icon: "heroicons-outline:user-circle",
                            children: [
                                {
                                    href: "/ecommerce/backend/add-product",
                                    label: ("addProduct"),
                                    active: pathname === "/ecommerce/backend/add-product",
                                },
                                {
                                    href: "/ecommerce/backend/customer-list",
                                    label: ("customerList"),
                                    active: pathname === "/ecommerce/backend/customer-list",
                                },
                                {
                                    href: "/ecommerce/backend/edit-product",
                                    label: ("editProduct"),
                                    active: pathname === "/ecommerce/backend/edit-product",
                                },
                                {
                                    href: "/ecommerce/backend/invoice",
                                    label: ("invoice"),
                                    active: pathname === "/ecommerce/backend/invoice",
                                },
                                {
                                    href: "/ecommerce/backend/order-details",
                                    label: ("orderDetails"),
                                    active: pathname === "/ecommerce/backend/order-details",
                                },
                                {
                                    href: "/ecommerce/backend/order-list",
                                    label: ("orderList"),
                                    active: pathname === "/ecommerce/backend/order-list",
                                },
                                {
                                    href: "/ecommerce/backend/purchase-list",
                                    label: ("purchaseList"),
                                    active: pathname === "/ecommerce/backend/purchase-list",
                                },
                                {
                                    href: "/ecommerce/backend/sellers",
                                    label: ("sellers"),
                                    active: pathname === "/ecommerce/backend/sellers",
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            groupLabel: ("pages"),
            id: "auth",
            menus: [
                {
                    id: "auth",
                    href: "/auth/login",
                    label: ("authentication"),
                    active: pathname.includes("/auth"),
                    icon: "heroicons-outline:lock-closed",
                    submenus: [
                        {
                            href: "/auth/login",
                            label: ("signInOne"),
                            active: pathname === "/auth/login",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/login2",
                            label: ("signInTwo"),
                            active: pathname === "/auth/login2",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/login3",
                            label: ("signInThree"),
                            active: pathname === "/auth/login3",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/register",
                            label: ("signUpOne"),
                            active: pathname === "/auth/register",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/register2",
                            label: ("signUpTwo"),
                            active: pathname === "/auth/register2",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/register3",
                            label: ("signUpThree"),
                            active: pathname === "/auth/register3",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/forgot-password",
                            label: ("forgotPasswordOne"),
                            active: pathname === "/auth/forgot-password",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/forgot-password2",
                            label: ("forgotPasswordTwo"),
                            active: pathname === "/auth/forgot-password2",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/forgot-password3",
                            label: ("forgotPasswordThree"),
                            active: pathname === "/auth/forgot-password3",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/look-screen",
                            label: ("lockScreenOne"),
                            active: pathname === "/auth/look-screen",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/look-screen",
                            label: ("lockScreenTwo"),
                            active: pathname === "/auth/look-screen2",
                            icon: "",
                            children: [],
                        },
                        {
                            href: "/auth/look-screen3",
                            label: ("lockScreenThree"),
                            active: pathname === "/auth/look-screen3",
                            icon: "",
                            children: [],
                        },
                    ],
                },
            ],
        },
        {
            groupLabel: "",
            id: "utility",
            menus: [
                {
                    id: "utility",
                    href: "/utility/blank-page",
                    label: ("utility"),
                    active: pathname.includes("/utility"),
                    icon: "heroicons-outline:view-boards",
                    submenus: [
                        {
                            href: "/utility/blank-page",
                            label: ("blankPage"),
                            active: pathname === "/utility/blank-page",
                            icon: "heroicons:document",
                            children: [],
                        },
                        {
                            href: "/utility/blog",
                            label: ("blog"),
                            active: pathname === "/utility/blog",
                            icon: "heroicons:square-2-stack",
                            children: [],
                        },
                        {
                            href: "/utility/faq",
                            label: ("faq"),
                            active: pathname === "/utility/faq",
                            icon: "heroicons:question-mark-circle",
                            children: [],
                        },
                        {
                            href: "/utility/invoice",
                            label: ("invoice"),
                            active: pathname === "/utility/invoice",
                            icon: "heroicons:clipboard-document-list",
                            children: [],
                        },
                        {
                            href: "/utility/pricing",
                            label: ("pricing"),
                            active: pathname === "/utility/pricing",
                            icon: "heroicons:currency-dollar",
                            children: [],
                        },
                        {
                            href: "/utility/profile",
                            label: ("profile"),
                            active: pathname === "/utility/profile",
                            icon: "heroicons:user-circle",
                            children: [],
                        },
                        {
                            href: "/utility/settings",
                            label: ("settings"),
                            active: pathname === "/utility/settings",
                            icon: "heroicons:wrench-screwdriver",
                            children: [],
                        },
                        {
                            href: "/changelog",
                            label: ("changelog"),
                            active: pathname.includes("/changelog"),
                            icon: "heroicons:arrow-trending-up",
                            children: [],
                        },
                        {
                            href: "/blocks/basic-widget",
                            label: ("basicWidget"),
                            active: pathname === "/blocks/basic-widget",
                            icon: "heroicons-outline:home",
                            children: [],
                        },
                        {
                            href: "/blocks/statistic-widget",
                            label: ("statisticsWidget"),
                            active: pathname === "/blocks/statistic-widget",
                            icon: "heroicons-outline:home",
                            children: [],
                        },
                        {
                            href: "/icons",
                            label: ("icons"),
                            active: pathname.includes("/icons"),
                            icon: "heroicons-outline:emoji-happy",
                            children: [],
                        },
                    ],
                },
            ],
        },
        {
            groupLabel: "",
            id: "icons",
            menus: [],
        },
    ];
}


